import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'checkValue',
  standalone: true,
})
export class CheckValuePipe implements PipeTransform {
  constructor() {}

  transform(value: any, args?: any): string {
    // return value || '_';
    return value || value === 0 ? value : '_';
  }

}
